import { NodeTypeKeys } from '../../utils/NodeTypeKeys';
import { Position } from '../../types';
import { Leaf } from '../Leaf';
import { Leaf as ILeaf } from '../../types';

const displayWebContentAllowedNodeTypes = [NodeTypeKeys.sendEmailNodeType, NodeTypeKeys.endOfFlowNodeType];

export class DisplayWebContentNode extends Leaf {
  public constructor(
    id: string,
    allowedNodeTypes: string[] = displayWebContentAllowedNodeTypes,
    position: Position = undefined,
    next: ILeaf = undefined,
    isHidden: boolean = undefined,
  ) {
    super(id, NodeTypeKeys.displayWebContentNodeType, allowedNodeTypes, { isHidden, next, position });
  }
}
